import BaseService from './base.service'
import Store from '@/store/index'

const API_URL = process.env.VUE_APP_API_URL
const CURRENCY = Store.state?.configAccount?.settings?.CURRENCY ? Store.state?.configAccount?.settings?.CURRENCY : process.env.VUE_APP_CURRENCY_CODE

class TransactionService extends BaseService {
    apiSubmitTransaction(data){
        return this.post(API_URL + 'api/lotto/transact',{
            currency: CURRENCY,
            bets:data
        }).then((response) =>{
            return response.data;
        })

    }
}
export default new TransactionService()
